import ProductFeatureItem from "./ProductFeatureItem"
import articlesIcon from '../../assets/icons/battery.svg'
import chatIcon from '../../assets/icons/chat_phone.svg'
import stethoscopeIcon from '../../assets/icons/stethoscope.svg'
import medicationIcon from '../../assets/icons/capsule.svg'

function ProductArticle({article_heading, summary, article_text, article_img, img_alt_text}) {
  return (
    <article className="product_article">
        <div>
            <img loading="lazy" src={article_img} alt={img_alt_text} />
        </div>
        <div>
            <p style={{marginBottom: '0.5rem'}} className="pill_text">Personalized Health Experience</p>
            <h1>{article_heading}</h1>
            <p className="summary">{summary}</p>
            <ul className="features-list">
                <ProductFeatureItem icon={stethoscopeIcon}feature_text="Appointment reminders" icon_alt_text="stethoscope icon" />
                <ProductFeatureItem icon={chatIcon} feature_text="Direct chats with our in-built AI tool and get immediate feedback" icon_alt_text="chat icon" />
                <ProductFeatureItem icon={medicationIcon} feature_text="Medication management" icon_alt_text="medication icon" />
                <ProductFeatureItem icon={articlesIcon} feature_text="Customized articles to suit your health status" icon_alt_text="articles icon"/>
            </ul>
            <button className="trynow">Try now</button>
        </div>
    </article>
  )
}

export default ProductArticle